/* unplugin-vue-components disabled */import script from "./BookingForOthers.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingForOthers.vue?vue&type=script&setup=true&lang=js"

import "./BookingForOthers.vue?vue&type=style&index=0&id=7bb28f8f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bb28f8f"]])

export default __exports__